// client/src/modules/explorer/index.ts
import type { ModuleManifest } from '../types';
import { navItems } from './nav';
import { routes } from './routes';

/**
 * Central Command module manifest (P6)
 *
 * Mission control hub providing executive-level visibility across all modules.
 * Flows from strategic KPIs down through operational summaries into raw data
 * and system health infrastructure.
 *
 * - Executive: Financial dashboard (P&L, balance sheet, cash flow, AR/AP)
 * - Operations: Composed summary cards from Projects, Support, Field Service
 * - Sales: Composed summary cards from CRM, Quoting
 * - Fleet & Assets: Composed summary cards from Fleet, compliance
 * - Data Health: Connections, sync status, error monitoring
 * - Data Browser: Browse any Firestore collection
 */
export const explorerModule: ModuleManifest = {
  id: 'P6',
  name: 'Central Command',
  shortName: 'Command',
  description: 'Mission control — executive KPIs, operational summaries, and data infrastructure',
  icon: '📡',
  status: 'live',
  urlPrefix: '/command',
  routes,
  navItems,
};

export default explorerModule;
